'use client';

import { forwardRef, ComponentPropsWithoutRef } from 'react';
import { cn } from '@ecom/helper-react-class-combine';

export const Form = forwardRef<HTMLFormElement, ComponentPropsWithoutRef<'form'>>(
  ({ className, ...props }, ref) => (
    <form ref={ref} className={cn('text-base', className)} {...props} />
  ),
);
Form.displayName = 'Form';
